<template>
  <v-app>
    <portal-sysbar></portal-sysbar>
    <div class="main-content">
      <portal-aside></portal-aside>
      <portal-title :title="$t('message.aside.detail', { value: 'default' })">
      </portal-title>
      <portal-breadcumb></portal-breadcumb>

      <div class="content">
        <v-row >
          

          <v-col md="3">
            <v-card class="text-center" flat>
              <v-card-text>
                
                <apex-charts type="radialBar" height="220" :options="donutChartOptions"
                  :series="donutSeries"></apex-charts>
                <h3 style="color: #00475a">
                  {{ $t("message.page.availableLoco", { value: "default" }) }}
                </h3>
              </v-card-text>
            </v-card>
            <v-card flat class="mt-10">
              <v-card-text class="text-center">
                <v-icon size="200" color="#F0F0F0"> mdi-train </v-icon>
                <p class="notice text-center"></p>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col>
            <v-row class="mb-2">
              <v-col md="6">
                <v-row class="py-0">
                  <v-col>
                    <v-switch v-model="filters" inset :label="$t('message.dispoc.past', { value: 'default' })" value="past" @change="updateData()"></v-switch>
                  </v-col>
                </v-row>
              </v-col>
              <v-col><v-text-field v-model="search" append-icon="mdi-magnify"
                  :label="$t('message.search', { value: 'default' })" single-line hide-details></v-text-field></v-col>
            </v-row>
            <v-data-table :headers="headers" :items="filterArray()" :search="search" class="elevation-1 dp"
              hide-default-header :loading="loading" :loading-text="$t('message.loadingText', { value: 'default' })" 
              :item-class="getMyClass" >
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th style="cursor: pointer" v-for="item in headers" :key="item.value"
                      @click="changeSort(item.value)">
                      {{ item.text }}
                      <v-icon style="float: right">{{ item.icon }}</v-icon>
                    </th>
                  </tr>
                </thead>
              </template>
              <template v-slot:[`item.dates`]="{ item }">
                {{
                  formatedDate(item.startDate)
                }}
                -
                {{
                  formatedDate(item.endDate) }}
              </template>
              <template v-slot:[`item.ecmCode`]="{ item }">
                {{
                  ecmFilter(item.ecmCode, item.ecmName)
                }}
              </template>
              <template v-slot:[`item.asset`]="{ item }">
                <span :class="isNotTitular(item)">
                  {{ item.asset }}
                </span>
              </template>
              <template v-slot:[`item.locomotive.status`]="{ item }">
                <v-chip dark :color="getColor(item.locomotive.status)"
                  :text-color="getTextColor(item.locomotive.status)" style="text-transform: uppercase"
                  v-if="item.locomotive.status != ''">
                  {{ item.locomotive.status }}
                </v-chip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import ApexCharts from "vue-apexcharts";
import { mapGetters } from "vuex";
import CoreService from "@/services/CoreService";
import { formatMagicDate, getDefaultPeriod } from "@/shared/DateHelper";
import { getECM } from "@/shared/Helper";

//radial bar label
var label = "0/0";
export default {
  title: "My fleet details",
  watch: {
    getterCurrentClient() {
      this.loadlocomotives();
    },
  },
  methods: {
 
    getMyClass(item){
      return item.leasedState
    },

    formatedDate(date) {
      if (date == "") {
        return "";
      }

      if (date == undefined) {
        return "";
      }

      if (date == null) {
        return "";
      }
      return formatMagicDate(date);
    },

    changeSort(column) {
      if (column == "assetnum") {
        if (this.isDesc) {
          this.dispoLoc.sort((a, b) => {
            return a.assetnum.localeCompare(b.assetnum);
          });
        } else {
          this.dispoLoc.sort((a, b) => {
            return b.assetnum.localeCompare(a.assetnum);
          });
        }
      } else if (column == "maintainer.name") {
        if (this.isDesc) {
          this.dispoLoc.sort((a, b) => {
            return a.maintainer.name.localeCompare(b.maintainer.name);
          });
        } else {
          this.dispoLoc.sort((a, b) => {
            return b.maintainer.name.localeCompare(a.maintainer.name);
          });
        }
      } else if (column == "contractType") {
        if (this.isDesc) {
          this.dispoLoc.sort((a, b) => {
            return a.contractType.localeCompare(
              b.contractType
            );
          });
        } else {
          this.dispoLoc.sort((a, b) => {
            return b.contractType.localeCompare(
              a.contractType
            );
          });
        }
      }
      this.isDesc = !this.isDesc;
    },

    updateData(){
      this.drawChart()
      this.filterArray()
    },

    filterArray(){
      return this.dispoLoc.filter((asset) => this.filters.includes(asset.leasedState))
    },

    ecmFilter(code, name) {
      return getECM({
        id: code,
        name: name
      })
    },

    drawChart() {
      this.donutSeries = [];
      this.donutChartOptions.labels.splice(
        0,
        this.donutChartOptions.labels.length
      );

      function reducer(prev, current) {
        if (
          [
            "MGW000",
            "MGWF",
            "MGWF-1",
            "MGWHU"
          ].includes(current.ecmCode)
        ) {
          return prev + 1;
        } else {
          return prev;
        }
      }

      if (this.filterArray().length > 0) {
        this.donutSeries.push(
          (100 * this.filterArray().reduce(reducer, 0)) / this.filterArray().length
        );
      } else {
        this.donutSeries.push(0);
      }
      this.getLabel();
    },

    isNotTitular(item) {
      if (item.assignmentType == 'Titulaire') {
        return "normal";
      }
      return "italic";
    },

    async loadlocomotives() {
      this.loading = true;
      this.dispoLoc = [];
      CoreService.getLeasedAssetByPeriod(this.getterCurrentClient, getDefaultPeriod().start, getDefaultPeriod().end)
        .then((response) => {
          this.dispoLoc = response.data;
          this.drawChart();
          this.loading = false
        })
        .catch(() => {
          this.dispoLoc = [];
          this.drawChart();
          this.loading = false
        });
    },

    getLabel() {
      function reducer(prev, current) {
        if (
          [
            "MGW000",
            "MGWF",
            "MGWF-1",
            "MGWHU"
          ].includes(current.ecmCode)
        ) {
          return prev + 1;
        } else {
          return prev;
        }
      }
      label = this.filterArray().reduce(reducer, 0) + "/" + this.filterArray().length;
    },

    getLocale(value) {
      if (value == "Titulaire") {
        return "message.page.titular";
      }

      if (value == "Reserve") {
        return "message.page.reserve";
      }

      if (value == "Performance") {
        return "message.page.performance";
      }

      if (value == "Spot") {
        return "message.page.spot";
      }
    },
    getColor(value) {
      if (this.availableStatus.includes(value)) {
        return "#5dea4c";
      } else if (value == "MAINTENANCE") {
        return "#EEBB07";
      }
      return "#df0024";
    },

    getValue(value) {
      if (value) {
        return "message.page.available";
      }
      return "message.page.maintenance";
    },

    getTextColor(value) {
      if (value == "MAINTENANCE") {
        return "#00475A";
      }
      return "#FFF";
    },
  },
  name: "DispoPage",
  data: () => ({
    items: [],
    filters: ["leased","future"],
    availableStatus: [
      "MGW000",
      "MGWF",
      "MGWF-1",
      "MGWHU"
    ],
    search: "",
    loading: true,
    dispoLoc: [],
    donutSeries: [],
    isDesc: false,
    donutChartOptions: {
      chart: {
        type: "radialBar",
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: "70%",
          },
          dataLabels: {
            name: {
              show: false,
            },
            enabled: false,
            textAnchor: "middle",
            value: {
              show: true,
              fontSize: "30px",
              fontWeight: "bolder",
              color: "#00475a",
              formatter: function () {
                return label;
              },
            },
          },
        },
      },
      labels: [],
      fill: {
        colors: ["#9ad6c5"],
      },
    },
  }),
  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
    ApexCharts,
  },
  computed: {
    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
    }),

    headers() {
      return [
        {
          text: this.$t("message.infoloc.locomotive", { value: "default" }),
          align: "start",
          sortable: true,
          value: "asset",
          icon: "mdi-sort-alphabetical-variant",
        },
        {
          text: "ECM",
          sortable: true,
          value: "ecmCode",
          icon: "mdi-sort-variant",
        },
        {
          text: "Agreement",
          sortable: true,
          value: "agreement.referenceju",
          icon: "mdi-sort-variant",
        },
        {
          text: this.$t("message.page.contractType", { value: "default" }),
          sortable: true,
          value: "agreement.contractType",
          icon: "mdi-sort-variant",
        },
        {
          text: this.$t("message.page.assignment", { value: "default" }),
          sortable: true,
          value: "dates",
        }
      ];
    },
  },
  mounted() {
    this.loadlocomotives();
  },
};
</script>

<style scoped>
.portal-green-bg {
  height: 59px;
  color: #fff;
}

.dp.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  color: #fff;
  font-size: 16px;
}

.theme--light.v-icon {
  color: #fff;
}

.dp.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th:hover {
  color: #fff;
}

.dp {
  color: #00475a;
  font-weight: bolder;
}

.portal-deep-blue-bg {
  height: 59px;
  color: #fff;
  text-transform: uppercase;
}

.italic {
  font-style: italic;
  font-weight: normal;
}

.normal {
  font-style: normal;
  font-weight: bold;
}

.v-card__text {
  padding: 0px;
}
</style>
